var _defs, _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-nz",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs30"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "nz-c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M0 0h600v300H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nz-d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m0 0 300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M0 0v.5L1 0z",
    transform: "translate(0 -.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M0 0v-.5L1 0z",
    transform: "rotate(-36 .5 -.2)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    id: "use21",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    id: "use23",
    transform: "rotate(72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    id: "use25",
    transform: "rotate(-72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    id: "use27",
    transform: "scale(-1 1) rotate(72)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path32",
    fill: "#00247d",
    fillRule: "evenodd",
    d: "M0 0h640v480H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(-111 36.1) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use34",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#fff",
    transform: "matrix(45.4 0 0 45.4 900 120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use36",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#cc142b",
    transform: "matrix(30 0 0 30 900 120)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "rotate(82 525.2 114.6) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use40",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#fff",
    transform: "rotate(-82 519 -457.7) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use42",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#cc142b",
    transform: "rotate(-82 519 -457.7) scale(25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "rotate(82 525.2 114.6) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use46",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#fff",
    transform: "rotate(-82 668.6 -327.7) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use48",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#cc142b",
    transform: "rotate(-82 668.6 -327.7) scale(30)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(-111 36.1) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use52",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#fff",
    transform: "matrix(50.4 0 0 50.4 900 480)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use54",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#cc142b",
    transform: "matrix(35 0 0 35 900 480)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1592",
    fill: "#012169",
    strokeWidth: 0.5,
    d: "M0 0h320v240H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1594",
    fill: "#fff",
    strokeWidth: 0.5,
    d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1596",
    fill: "#c8102e",
    strokeWidth: 0.5,
    d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1598",
    fill: "#fff",
    strokeWidth: 0.5,
    d: "M120.5 0v240h80V0zM0 80v80h320V80z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path1600",
    fill: "#c8102e",
    strokeWidth: 0.5,
    d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.c13a64ec70248ccc41d6f5105b52c3d3.svg";
export { ForwardRef as ReactComponent };